import * as React from 'react';
import { AlignType, TDSnapshot, TDStatus, useTldrawApp } from 'sn-wb-tldraw';

import { Alignment } from './Alignment';
import { SelectionTools } from './SelectionTools';
import { TextPanel } from './TextPanel';

interface SelectedPanelProps {
  selectedIds: string[];
}

export function SelectedPanel({ selectedIds }: SelectedPanelProps): JSX.Element {
  const app = useTldrawApp();
  const zoom = app.useStore((s) => s.document.pageStates.page.camera.zoom);
  const getShapePoints = (currentId: string) =>
    app.getShapeUtil(app.getShape(currentId).type).getBounds(app.getShape(currentId));
  const hasMultipleSelectionSelector = selectedIds.length > 1;

  const selectedShapes = selectedIds.map((id) => app.getShape(id).name);
  const xPoints = selectedIds.map((id) => (getShapePoints(id).maxX + getShapePoints(id).minX) / 2);
  const yPoints = selectedIds.map((id) => app.getShape(id).point[1]);
  const xPoint = xPoints.reduce((a, b) => a + b, 0) / xPoints.length;
  const yPoint = Math.min(...yPoints);

  let content = <></>;
  const firstShape = app.getShape(selectedIds[0]);
  const pointX = (app.useStore((s) => s.document.pageStates.page.camera.point[0]) + xPoint) * zoom;
  const pointY =
    (app.useStore((s) => s.document.pageStates.page.camera.point[1]) + yPoint) * zoom - 90;
  const status = app.useStore((s) => s.appState.status);
  const selectedStickyText = app.useStore((s) => s.appState.selectedStickyText);

  if (
    firstShape.type !== 'sticker' &&
    firstShape.type !== 'comment' &&
    firstShape.type !== 'connector'
  ) {
    if (selectedShapes.every((v) => v === selectedShapes[0])) {
      if (firstShape && status !== TDStatus.Translating && status !== TDStatus.Creating)
        content = (
          <div
            className="flex  absolute top-0 left-0 origin-center "
            style={{
              transform: `translate(${pointX}px, ${pointY}px)`,
            }}
          >
            <div
              className="flex flex-row bg-primary-900 rounded-sm gap-7"
              style={{
                transform: `translate(-50%, 0)`,
                padding: '4px 8px',
              }}
            >
              {selectedStickyText !== '' && firstShape.name === 'Sticky' ? (
                <TextPanel />
              ) : (
                <SelectionTools
                  isFilled={firstShape.style.isFilled || false}
                  selectedShape={firstShape.type}
                  currentColor={firstShape.style.color}
                  currentSize={firstShape.style.size}
                />
              )}
            </div>
          </div>
        );
    } else if (hasMultipleSelectionSelector) {
      content = (
        <div
          className="flex  absolute top-0 left-0 origin-center "
          style={{
            transform: `translate(${pointX}px, ${pointY}px)`,
          }}
        >
          <div
            className="flex flex-row bg-primary-900 rounded-sm gap-7"
            style={{
              transform: `translate(-50%, 0)`,
              padding: '4px 8px',
            }}
          >
            <div className="flex gap-10 items-center cursor-pointer">
              <Alignment />
            </div>
          </div>
        </div>
      );
    }
  }

  return content;
}
